import { PERIPHERAL } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: `${PERIPHERAL}/relateTestCase`,
  params: null,
  extraParams: null,
  okAction: 'create',
  formatData(data) {
    data.peripheralId = this.extraParams?.peripheralId
    const relateTestCaseArr = data.relateTestCaseArr.map(item => {
      return item.id
    })
    data.testCaseIdList = relateTestCaseArr
    return data
  },
  view: {
    title: '关联用例',
    labelPosition: 'right',
    content: [
      {
        $id: 'relateTestCaseArr',
        label: '关联用例',
        $type: 'sky-relation-option',
        actions: {
          nativeOn: {
            click: 'peripheralRelationTestCase'
          }
        },
        $el: {
          multiple: true
        },
        rules: [{ notEmpty: '关联用例' }]
      }
    ]
  }
}
